import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { CartContext } from '../Cart Utility/CartManager';
import './CheckoutPage.css'; // Import CSS for styling

const CheckoutPage = () => {

    
   
    const cart = useContext(CartContext); // Use the Cart context
    const [paymentSuccess, setPaymentSuccess] = useState(false); // State to track payment status
    const [orderReceipt, setOrderReceipt] = useState(null); // State to store order receipt
    const navigate = useNavigate();

   

    let tempCart = cart.items;

    

    // Group items by their id and calculate the quantity for each item
    const groupedCart = tempCart.reduce((acc, item) => {
        const existingItem = acc.find((cartItem) => cartItem.product_id === item.product_id);
        if (existingItem) {
            existingItem.quantity += 1;
        } else {
            acc.push({ ...item, quantity: 1 });
        }
        return acc;
    }, []);

    localStorage.setItem('orderCart', JSON.stringify(groupedCart)); // Persist cart to localStorage

    const handleRemoveItem = (id) => {

        let removetempCart = cart.items
        removetempCart = removetempCart.filter((item) => item.product_id !== id); // Remove all instances of the item
        localStorage.setItem('cart', JSON.stringify(removetempCart)); // Persist cart to localStorage
        cart.setItems(removetempCart);
    };


    const calculateTotalPrice = () => {
        return groupedCart.reduce((total, item) => total + ((item.price * 1) || 0) * item.quantity, 0).toFixed(2);
    };

    const validateCart = () => {
        if (cart.items.length === 0) {
            alert('Your cart is empty. Please add items before proceeding to payment.');
            return false;
        }

        const invalidItems = cart.items.filter((item) => !item.product_id || !item.title || !item.price);
        if (invalidItems.length > 0) {
            alert('Your cart contains invalid items. Please review your cart.');
            return false;
        }

        return true;
    };

    const handlePayment = () => {
        if (!validateCart()) {
            return;
        }

        // Simulate payment processing
        setTimeout(() => {
            setPaymentSuccess(true);
            setOrderReceipt({
                items: groupedCart,
                total: calculateTotalPrice(),
                date: new Date().toLocaleString(),
            });
            // setCart([]); // Clear the cart after successful payment
            localStorage.setItem('cart', JSON.stringify([])); // Clear the cart after successful payment
            cart.setItems([]); // Clear the cart after successful payment
        }, 1000);
    };

    if (paymentSuccess && orderReceipt) {
        return (
                <div className="checkout-container">
                    <h1>Order Receipt</h1>
                    <div className="order-receipt">
                        <p><strong>Order Date:</strong> {orderReceipt.date}</p>
                        <ul>
                            {orderReceipt.items.map((item, index) => (
                                <li key={index}>
                                    {item.title} (x{item.quantity}) - ${(item.price*1)?.toFixed(2)} each
                                </li>
                            ))}
                        </ul>
                        <p><strong>Total Price:</strong> ${orderReceipt.total}</p>
                        <button className="home-button" onClick={() => navigate('/')}>
                            Back to Home
                        </button>
                    </div>
                </div>
        );
    }

    return (
        <div className="app-layout">
            <div className="checkout-container">
                <h1>Checkout</h1>
                {groupedCart.length === 0 ? (
                    <p>Your cart is empty. Please add items to your cart.</p>
                ) : (
                    <div className="cart-items">
                        {groupedCart.map((item, index) => (
                            <div key={index} className="cart-item">
                                <img
                                    src={item.images}
                                    alt={item.title}
                                    className="cart-item-image"
                                    loading="lazy"
                                />
                                <div className="cart-item-info">
                                    <h2>{item.title}</h2>
                                    <p>Price: ${(item.price * 1)?.toFixed(2)}</p>
                                    <p>Quantity: {item.quantity}</p>
                                    <button
                                        className="remove-item-button"
                                        onClick={() => handleRemoveItem(item.product_id)}
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>
                        ))}
                        <div className="checkout-summary">
                            <p><strong>Total Price:</strong> ${calculateTotalPrice()}</p>
                        </div>
                        <div className="checkout-actions">
                            <button className="payment-button" onClick={handlePayment}>
                                Proceed to Payment
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CheckoutPage;